
const ProductDetails = ()=>{
    return(
        <div>
            <h1>ProductDetails</h1>
        </div>
    )
}

export default ProductDetails;